/**
 * ClientFilters - Filtros para lista de clientes
 * Tabs: Todos, Premium, Free, Pendientes, Inactivos
 */
import { cn } from "../../lib/utils";

const FILTERS = [
  { id: "all", label: "Todos", color: "text-white" },
  { id: "premium", label: "Premium", color: "text-[#D4AF37]" },
  { id: "free", label: "Free", color: "text-[#888]" },
  { id: "pending", label: "Pendientes", color: "text-orange-400" },
  { id: "inactive", label: "Inactivos", color: "text-red-400" },
];

const ClientFilters = ({
  activeFilter,
  onFilterChange,
  counts = {}
}) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {FILTERS.map((filter) => {
        const isActive = activeFilter === filter.id;
        const count = counts[filter.id];
        
        return (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={cn(
              "flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all",
              isActive
                ? "bg-[#1A1A1A] border border-[#3A3A3A]"
                : "bg-transparent border border-transparent hover:bg-[#1A1A1A]",
              isActive ? filter.color : "text-[#666]"
            )}
            data-testid={`filter-${filter.id}`}
          >
            <span>{filter.label}</span>
            {count !== undefined && (
              <span className={cn(
                "text-xs px-1.5 py-0.5 rounded",
                isActive ? "bg-white/10" : "bg-[#2A2A2A]"
              )}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ClientFilters;
